<template>
  <div id="app">
    <!-- 缓存的页面，缓存$route.meta.keepAlive为true的组件 -->
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不缓存的页面，不缓存$route.meta.keepAlive为false的组件 -->
    <router-view v-if="!this.$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import dictionaryApi from "@/api/Systems/Dictionaryapi";
export default {
  name: "App",
  created() {
    // 入口页面调用字典请求并全局设置字典值
    // 取值 window.GLOBAL_DICT[字典名称] = [对应字典数据值]
    // 取值样例 window.GLOBAL_DICT.Sex = [对应字典数据值]
    // dictionaryApi.initGlobalDicCatch();
  },
  mounted() {
    // dictionaryApi.initGlobalDicCatch();
  },
};
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>